"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";

export default function AttractionsContent() {

    const [Attractions, setAttractions] = useState([]);
    useEffect(() => {
        const fetchAttractions = async () => {
            try {
                const response = await fetch('/api/parkattractions');

                if (response.ok) {
                    const data = await response.json();

                    setAttractions(data);
                }
            } catch (error) {
                console.error('Failed to fetch Faqs:', error);
            }
        };
        fetchAttractions();
    }, []);
    return (
        <>
            <div
                className="breadcrumb-wrapper bg-cover"
                style={{ backgroundImage: 'url("/assets/img/breadcrumb-bg.jpg")' }}
            >
                <div className="shape-image float-bob-y">
                </div>
                <div className="container">
                    <div className="breadcrumb-wrapper-items">
                        <div className="page-heading">
                            <div className="breadcrumb-sub-title">
                                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                    Attractions
                                </h1>
                            </div>
                            <ul
                                className="breadcrumb-items wow fadeInUp"
                                data-wow-delay=".5s"
                            >
                                <li>
                                    <Link href={`/`}> Home </Link>
                                </li>
                                <li>
                                    <i className="fa-sharp fa-solid fa-slash-forward" />
                                </li>
                                <li>Attractions</li>
                            </ul>
                        </div>
                        <div className="breadcrumb-image">
                            <div className="bar-shape">
                                <Image
                                    src="/assets/img/breadcrumb-bar.png"
                                    width={631}
                                    height={604}
                                    alt="img"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container py-5">
                <div className="row">
                    {Attractions.length > 0 ? (
                        Attractions.map((item, index) => (
                            <div className="col-lg-4 col-md-6 col-sm-12" key={item._id || index}>
                                <div className="card mb-4">
                                    <div className="card-body p-0">
                                        <div className="service-box-items mt-0">
                                            <div className="service-thumb">
                                                <img
                                                    src={item.imgSrc}
                                                    width={346}
                                                    height={236}
                                                    alt={item.title || "img"}
                                                    style={{ objectFit: 'cover' }}
                                                />
                                            </div>
                                            <div className="service-content p-0">
                                                <h3 className="text-center">
                                                    {item.title}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-white">Loading facilities...</div>
                    )}
                </div>
            </div>
        </>
    );
}
